@use "variables" as *;

.menuItem:hover {
  background-color: transparent !important;
}

.button {
  margin: 0 !important;
  width: 100%;
}
